import React from 'react';
import ChatInput from './ChatInput';
import type { WebSearchMode } from './ChatInput';
import { UploadedFile } from './FileUpload';
import { useTheme } from '../context/ThemeContext';

interface WelcomeScreenProps {
  inputMessage: string;
  isLoading: boolean;
  uploadedFiles: UploadedFile[];
  hasEverHadFile?: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSendMessage: (e: React.FormEvent) => void;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDeleteFile: (index: number) => void;
  webSearchMode?: WebSearchMode;
  isImageGenerationEnabled?: boolean;
  isDeepResearchEnabled?: boolean;
  onWebSearchModeChange?: (mode: WebSearchMode) => void;
  onImageGenerationToggle?: (enabled: boolean) => void;
  onDeepResearchToggle?: (enabled: boolean) => void;
  isAgentMode?: boolean;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({
  inputMessage,
  isLoading,
  uploadedFiles,
  hasEverHadFile = false,
  onInputChange,
  onSendMessage,
  onFileUpload,
  onDeleteFile,
  webSearchMode,
  isImageGenerationEnabled,
  isDeepResearchEnabled,
  onWebSearchModeChange,
  onImageGenerationToggle,
  onDeepResearchToggle,
  isAgentMode = false
}) => {
  const { colors } = useTheme();

  return (
    <div style={{
      width: '700px',
      maxWidth: '100%',
      textAlign: 'center'
    }}>
      <h1 style={{
        color: colors.textPrimary,
        fontSize: '2.75rem',
        marginBottom: '40px',
        fontWeight: '700',
        letterSpacing: '-0.03em',
        lineHeight: 1.2,
        background: 'linear-gradient(90deg, #2563eb 0%, #7c3aed 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}>How can I help you today?</h1>

      <div style={{
        backgroundColor: colors.surface,
        borderRadius: '20px',
        padding: '0px',
        //boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        //border: '1px solid rgba(116, 156, 243, 0.5)',
        maxWidth: '700px'
      }}>
        <ChatInput
          inputMessage={inputMessage}
          isLoading={isLoading}
          uploadedFiles={uploadedFiles}
          hasEverHadFile={hasEverHadFile}
          onInputChange={onInputChange}
          onSendMessage={onSendMessage}
          onFileUpload={onFileUpload}
          onDeleteFile={onDeleteFile}
          webSearchMode={webSearchMode}
          isImageGenerationEnabled={isImageGenerationEnabled}
          isDeepResearchEnabled={isDeepResearchEnabled}
          onWebSearchModeChange={onWebSearchModeChange}
          onImageGenerationToggle={onImageGenerationToggle}
          onDeepResearchToggle={onDeepResearchToggle}
          isChatStarted={false}
          isAgentMode={isAgentMode}
        />
      </div>
    </div>
  );
};

export default WelcomeScreen;
